import type { GetApiV1ThreeLetterCodePartnerAdminsGroupsId200 } from '@fukuri-admins/apis/client/gen/model';
import { getThreeLetterCode } from '@fukuri-admins/utils/common/cookies';
import { useGetPartnerAdminsGroup } from './useGetPartnerAdminsGroup';

type IUseGroupDetail = (id: number) => {
  state: {
    data: GetApiV1ThreeLetterCodePartnerAdminsGroupsId200;
  };
};

/**
 * グループ詳細のコンポーネントフック
 *
 * @param id - グループID
 * @returns state.data - グループ詳細データ
 */
export const useGroupDetail: IUseGroupDetail = id => {
  const threeLetterCode = getThreeLetterCode();

  const { data } = useGetPartnerAdminsGroup({
    threeLetterCode,
    id,
  });

  return {
    state: {
      data,
    },
  };
};
